export class RegistrationModerationVerificationModel {
    constructor(
        public key: number,
        public status: string,
        public rejectReason: string,
        public annualIncome: number,

        public isDocReadable: string,
        public hasBarcode: string,
        public afterPeriod: string,
        public barcode: string,
        public rejectRemarksSystem: number,
        public originalDesignation: string,
        public curOrganizationName: string,
        public designation: string,
    ) { }
}